import React from 'react'

class PrivacySection extends React.Component {
  state = {}

  componentDidMount () {}

  render () {
    var content = <div>Privacy section</div>

    return content
  }
}

module.exports = PrivacySection
